
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { PostService } from '../../services/post-service';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { UrlsUtils } from '../../utils/UrlsUtils';
import { useFormik } from 'formik';
import LinearProgress from '@mui/material/LinearProgress';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 860,
  maxHeight: 780,
  bgcolor: 'background.paper',
  borderRadius: '6px',
  border: '1px solid #fff',
  boxShadow: 24,
  p: 2,
  textAlign: 'center',
  overflowY: 'auto',
};

const defaultCategory = { name: 'name-none', slug: 'None' };
const defaultHashtag = { name: 'name-none', slug: 'None' };

export default function MultiArticlesFilter({ onUpdate, index, widget, _all_origin_domain,
  isTrendingTopics = false, isMultipleArticles = false }) {

  const imgBkRef = useRef();
  const dataDefault = {
    title: '',
    text: '',
    url: '',
    image_bk_url: '',
  };

  const pageSizeCat = 50;
  const pageSizeHashtag = 25;
  const searchHashtagRef = useRef();
  const allOriginDomain = _all_origin_domain;
  const [numberArticles, setNumberArticles] = useState(20);
  const [categoryList, setCategoryList] = useState([]);
  const [category, setCategory] = useState(defaultCategory);
  const [searchHashtagValue, setSearchHashtagValue] = useState('');
  const [hashtagList, setHashtagList] = useState([]);
  const [hashtag, setHashtag] = useState(defaultHashtag);
  const [hashcount, setHashcount] = useState(0);
  const [originDomain, setOriginDomain] = useState(allOriginDomain[0]);
  const [showArticleImages, setShowArticleImages] = useState(false);
  const isInModification = Object.keys(widget[0]?.data)?.length > 0;

  //Mui Modal
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  //const handleClose = () => setOpenModal(false);
  const [isLoading, setIsLoading] = useState(false);

  //Number
  const handleChange = (event) => {
    if (event.target.value > 0 && event.target.value !== '') {
      setNumberArticles(event.target.value);
    }
  };

  //Menu Origin Domain
  const [anchorElDomain, setAnchorElDomain] = useState(null);
  const mopenDomain = Boolean(anchorElDomain);
  const handleDomainClick = (event) => {
    setAnchorElDomain(event.currentTarget);
  };
  function handleDomainClose() {
    setAnchorElDomain(null);
  }

  //Menu Category
  const [anchorElCategory, setAnchorElCategory] = useState(null);
  const mopenCategory = Boolean(anchorElCategory);
  const handleCategoryClick = (event) => {
    setAnchorElCategory(event.currentTarget);
  };
  function handleCategoryClose() {
    setAnchorElCategory(null);
  }

  //Menu Hashtag
  const [anchorElHashtag, setAnchorElHashtag] = useState(null);
  const mopenHashtag = Boolean(anchorElHashtag);
  const handleHashtagClick = (event) => {
    setAnchorElHashtag(event.currentTarget);
  };
  function handleHashtagClose() {
    setAnchorElHashtag(null);
  }

  useEffect(() => {
    handleOpen();
    if (isInModification) {
      setNumberArticles(widget[0]?.data?.number);
      if (widget[0]?.data?.filters) {
        widget[0]?.data?.filters?.forEach(filter => {
          try {
            if (filter.value.length > 0 && filter.value.toLowerCase() !== 'none') {
              if (filter.field === 'origin_domain') {
                setOriginDomain(filter.value);
              } else if (filter.field === 'category_parent_slug') {
                //In realtà il name per il momento non viene salvato (name fittizio)
                setCategory({ name: 'name-' + filter.value, slug: filter.value });
              } else if (filter.field === 'tags_slug__in') {
                //In realtà il name per il momento non viene salvato (name fittizio)
                setHashtag({ name: 'name-' + filter.value, slug: filter.value });
              }
            }
          } catch (error) {
            console.error(error);
          }
        })
      }
      setShowArticleImages(widget[0]?.data?.show_article_images ? widget[0]?.data?.show_article_images : false);
    }
    //console.log('TrendingTopics in modifica: ', isInModification)
  }, [isInModification, widget]);

  //Formik
  const formik = useFormik({
    //initialValues: widget ? widget : dataDefault,
    initialValues: isInModification ? widget[0].data : dataDefault,
    enableReinitialize: true,
    onSubmit: values => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  //Gestione chiusura del modal
  function handleClose(event, reason) {
    //console.log(event, reason);
    switch (reason) {
      case 'backdropClick':
        return;
      case 'escapeKeyDown':
        return;
      default:
        setOpenModal(false);
    }
  }

  function createFilters() {
    let tempArr = [];
    if (originDomain?.toLowerCase() !== 'none') {
      tempArr.push({
        field: 'origin_domain',
        value: originDomain?.toLowerCase()
      })
    }
    if (category?.slug?.toLowerCase() !== 'none') {
      tempArr.push({
        field: 'category_parent_slug',
        value: category?.slug?.toLowerCase()
      })
    }
    if (hashtag?.slug?.toLowerCase() !== 'none') {
      tempArr.push({
        field: 'tags_slug__in',
        value: hashtag?.slug?.toLowerCase()
      })
    }
    return tempArr;
  }

  const fetchData = useCallback(async (_hashtag) => {
    setIsLoading(true);
    const categoryList = await PostService.getCategoryList({ page_size: pageSizeCat });
    const hashtagList = await PostService.getTagList({
      search_ns: _hashtag,
      page_size: pageSizeHashtag
    });

    if (categoryList.count === 0 || hashtagList.count === 0) {
      console.error(`No posts o backend for params`);
    } else {
      let varCat = categoryList.results;
      varCat.unshift(defaultCategory);
      setCategoryList(varCat);
      let varHash = hashtagList.results;
      varHash.unshift(defaultHashtag);
      setHashtagList(varHash);
      if (!isInModification) { setCategory(defaultCategory); setHashtag(defaultHashtag) }
    }
    //console.log('hashtagList: ', hashtagList.results);
    setHashcount(hashtagList.count)
    setIsLoading(false);
  }, [pageSizeCat, pageSizeHashtag, isInModification])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchData(searchHashtagValue);
    }, 250)
    return () => clearTimeout(delayDebounceFn)
  }, [fetchData, searchHashtagValue]);


  function imgError(image) {
    image.onError = "";
    image.src = "/img/logo-startupitalia-rocket.png";
    return true;
  }

  function handleChangeHash(event) {
    setSearchHashtagValue(searchHashtagRef.current.value);
    setHashtag(defaultHashtag);
  }

  function keyPress(event) {
    if (event.key === 'Enter') {
      setSearchHashtagValue(searchHashtagRef.current.value);
      setHashtag(defaultHashtag);
    }
  }

  return (
    <>
      <Modal
        aria-labelledby="tt-modal-title"
        aria-describedby="tt-modal-description"
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      //disableEscapeKeyDown={true} 
      >
        <Fade in={openModal}>
          <Box sx={style}>
            <Typography id="tt-modal-title" variant="h6" component="h2"
              style={{ marginBottom: "20px" }}>
              {isTrendingTopics &&
                (isInModification ? 'Trend Topics' : 'New Trend Topics')
              }
              {isMultipleArticles &&
                (isInModification ? 'Multiple Articles' : 'New Multiple Articles')
              }
            </Typography>
            {isTrendingTopics &&
              <>
                < div className="row" style={{ display: "flex", textAlign: "left" }}>
                  <div className="col-12">
                    <span className="fw-bold">Title:</span>
                    <input type="text" id="title" className="form-control" style={{ width: "100%" }}
                      onChange={formik.handleChange}
                      value={formik.values?.title}
                    />
                  </div>
                </div>
                <div className="row" style={{ display: "flex", textAlign: "left" }}>
                  <div className="col-12 mt-3">
                    <span className="fw-bold">Text:</span>
                    <input type="text" id="text" className="form-control" style={{ width: "100%" }}
                      onChange={formik.handleChange}
                      value={formik.values?.text}
                    />
                  </div>
                </div>
                <div className="row" style={{ display: "flex", textAlign: "left" }}>
                  <div className="col-12 mt-3">
                    <span className="fw-bold">URL:</span>
                    <input type="text" id="url" className="form-control" style={{ width: "100%" }}
                      onChange={formik.handleChange}
                      value={formik.values?.url}
                    />
                  </div>
                </div>
                <div className="row" style={{ minHeight: "106px", display: "flex", textAlign: "left" }}>
                  <div className="col-9 mt-3">
                    <span className="fw-bold">Image Background URL:</span>
                    <input type="text" id="image_bk_url" className="form-control" style={{ width: "100%" }}
                      onChange={formik.handleChange}
                      value={formik.values?.image_bk_url}
                    />
                  </div>
                  <div className="col-3 text-center align-self-center" >
                    <a type="button" href={UrlsUtils.recognizingUrl(formik.values?.image_bk_url) ? formik.values?.image_bk_url : null}
                      className="my-tooltip" title="Visualizza immagine" target="_blank" rel="noopener noreferrer">
                      <img src={formik.values?.image_bk_url && formik.values?.image_bk_url} ref={imgBkRef}
                        className="img-thumbnail mt-3" alt='Thumbnail url' onError={() => imgError(imgBkRef.current)}
                        style={{ maxHeight: "5rem", padding: "0px", border: "0px", boxShadow: "0px 0px 5px 0px #6c757d", backgroundColor: "whitesmoke" }}></img>
                    </a>
                  </div>
                </div>
              </>
            }

            <div className="row" style={{ margin: "auto", textAlign: "left" }}>
              <div className="col-3 p-0">
                <div className="fw-bold">Number of articles</div>
                <TextField
                  id="outlined-number"
                  label={null}
                  type="number"
                  defaultValue={numberArticles}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: false,
                  }}
                  inputProps={{
                    inputMode: 'numeric', pattern: '[0-9]*',
                    style: { width: "100%", minWidth: "60px", height: "5px" }, min: 1, max: 50
                  }}
                  sx={{
                    '& legend': { display: 'none' },
                    '& fieldset': { top: 0 },
                  }}
                />
                {isTrendingTopics &&
                  <FormGroup aria-label="show_article_images">
                    <FormControlLabel
                      sx={{
                        marginTop: "20px",
                        marginLeft: 0,
                        flexDirection: 'row',
                        '.MuiFormControlLabel-label': {
                          fontWeight: "600",
                        },
                      }}
                      value="start"
                      control={
                        <Checkbox
                          checked={showArticleImages ? showArticleImages : false}
                          onChange={(event) => setShowArticleImages(event.target.checked)}
                          inputProps={{ 'aria-label': 'controlled' }}
                          style={{padding: 0}}
                        />
                      }
                      label="ShowArticleImages"
                      labelPlacement="start" />
                  </FormGroup>
                }
              </div>
              <div className="col-9 p-0">
                <div className="row" style={{ margin: "auto", textAlign: "left" }}>
                  <div className="col-12" style={{ padding: "6px 0" }}>
                    <div className="fw-bold">Origin Domain</div>
                    <button type="button" className="btn btn-light" data-bs-display="static" aria-expanded="false"
                      onClick={handleDomainClick} style={{
                        width: "100%", minWidth: "200px",
                        backgroundColor: "#0a58ca", color: "white"
                      }} >
                      {originDomain}
                    </button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorElDomain}
                      open={mopenDomain}
                      onClose={handleDomainClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      {allOriginDomain.map((e, i) => {
                        return <MenuItem key={i}
                          onClick={() => {
                            handleDomainClose(); setOriginDomain(e);
                          }}>{e}</MenuItem>
                      })}
                    </Menu>
                  </div>
                </div>

                <div className="row p-0" style={{ margin: "auto", textAlign: "left" }}>
                  <div className="col-12" style={{ padding: "6px 0" }}>
                    <div className="fw-bold">Category</div>
                    <button type="button" className="btn btn-light" data-bs-display="static" aria-expanded="false"
                      onClick={handleCategoryClick} style={{
                        width: "100%", minWidth: "200px",
                        backgroundColor: "#0a58ca", color: "white"
                      }} >
                      {category?.slug}
                    </button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorElCategory}
                      open={mopenCategory}
                      onClose={handleCategoryClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      {categoryList.map((e, i) => {
                        return <MenuItem key={i} onClick={() => {
                          handleCategoryClose(); setCategory(e);
                        }} >{e.slug}</MenuItem>
                      })}
                    </Menu>
                  </div>
                </div>

                <div className="row p-0" style={{ margin: "auto", textAlign: "left" }}>
                  <div className="col-12" style={{ padding: "6px 0" }}>
                    <div className="fw-bold">Hashtag</div>
                    <div className="input-group">
                      <input type="text" className="form-control" placeholder="Search Hashtag"
                        style={{ padding: "6px" }}
                        onKeyDown={(e) => keyPress(e)}
                        ref={searchHashtagRef}
                        defaultValue={searchHashtagValue}
                        onChange={handleChangeHash}
                        aria-label="Search hashtag" aria-describedby="button-search" />
                      <button className="btn btn-primary" type="button" id="button-search-slug"
                        onClick={() => { setSearchHashtagValue(searchHashtagRef.current.value); setHashtag(defaultHashtag); }}>
                        <FontAwesomeIcon icon={['fas', 'search']} size={'1x'} color={'white'} />
                      </button>
                    </div>
                    {!isLoading ?
                      <>
                        <button type="button" className="btn btn-light" data-bs-display="static" aria-expanded="false"
                          onClick={handleHashtagClick} style={{
                            width: "100%", minWidth: "200px",
                            backgroundColor: "#0a58ca", color: "white"
                          }} >
                          {hashtag?.slug}
                        </button>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorElHashtag}
                          open={mopenHashtag}
                          onClose={handleHashtagClose}
                          MenuListProps={{
                            'aria-labelledby': 'basic-button',
                          }}
                        >
                          {hashtagList.map((e, i) => {
                            return <MenuItem key={i} onClick={() => {
                              handleHashtagClose(); setHashtag(e);
                            }} >{e.slug}</MenuItem>
                          })}
                        </Menu>
                      </>
                      : <button type="button" className="btn btn-light" data-bs-display="static" aria-expanded="false"
                        style={{
                          width: "100%", minWidth: "120px", marginTop: "4px",
                          backgroundColor: "#0a58ca", color: "white"
                        }} >
                        <Box sx={{ width: '100%' }}>
                          Ricerca...
                          <LinearProgress />
                        </Box>
                      </button>
                    }
                  </div>
                </div>
                <div className='justify-content-center p-1'>
                  {searchHashtagValue === '' ?
                    hashcount + ` hashtag totali (seleziona tra i ${pageSizeHashtag} in elenco o fai una ricerca)`
                    :
                    hashcount + ' hashtag trovati nella ricerca'
                  }
                </div>
              </div>

            </div>


            <div className="row mt-4 pt-1">
              <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <button type="button" className="btn btn-secondary"
                  style={{ minWidth: '6rem', marginLeft: '10px', float: "left" }}
                  onClick={() => { ((widget[0]?.data && isInModification) ? onUpdate(null, -1) : onUpdate(null, index)); handleClose(); }}>
                  Chiudi
                </button>
              </div>
              <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <button type="button" className="btn btn-success"
                  style={{ minWidth: '6rem', marginRight: '10px', float: "right" }}
                  onClick={() => {
                    if (isTrendingTopics) onUpdate(
                      {
                        title: formik.values.title,
                        text: formik.values.text,
                        url: formik.values.url,
                        image_bk_url: formik.values.image_bk_url,
                        number: numberArticles,
                        show_article_images: showArticleImages,
                        filters: createFilters()
                      },
                      index
                    );
                    if (isMultipleArticles) onUpdate(
                      {
                        number: numberArticles,
                        filters: createFilters()
                      },
                      index
                    );
                    handleClose();
                  }}>
                  Conferma
                </button>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal >
    </>
  );
}